/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description DeleteClaimAction Modal
 */
import { Button, ButtonProps, App, Tooltip } from 'antd';
import { DeleteOne } from '@icon-park/react';

import { MODAL_TYPES } from '../modal';
import useDeleteClaimActivityAction from 'hooks/claim/mutate/useDeleteClaimActivityAction';
import { WORKLIST_ENTITY_TYPES } from 'app-constants/claims/workLists';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

export interface IProps extends ButtonProps {
	activity: ClaimRequest.IActivityType;
}

/**
 * DeleteClaimAction
 * @returns {React.FC<IProps>} DeleteClaimAction
 */

const DeleteClaimAction: React.FC<IProps> = ({ activity, ...restProps }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useDeleteClaimActivityAction();
	const { canEditClaims } = useAppStoreValues().userAccess;
	const disabled = restProps.disabled || !canEditClaims;

	const handleDelete = () => {
		modal.confirm({
			...MODAL_TYPES.confirm,
			width: 560,
			title: 'Delete Action',
			content:
				'Are you sure you want to delete this claim activity? If it hasn’t been used in any claim, it will be permanently deleted. Otherwise, it will be marked as disabled.',
			okText: 'Delete',
			okButtonProps: { danger: true },
			cancelText: 'Cancel',
			onOk: async () => {
				await mutateAsync({ model: { activityTypeId: activity.id, entityType: WORKLIST_ENTITY_TYPES.claim } });
			},
		});
	};

	return (
		<Tooltip title={canEditClaims ? 'Delete' : NO_ACCESS_TOOLTIP_TEXT}>
			<Button danger icon={<DeleteOne />} onClick={handleDelete} {...restProps} disabled={disabled} />
		</Tooltip>
	);
};

export default DeleteClaimAction;
